import { render, staticRenderFns } from "./GLStat.vue?vue&type=template&id=5a648feb&"
import script from "./GLStat.vue?vue&type=script&lang=js&"
export * from "./GLStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports